import { render, staticRenderFns } from "./movecartoondata.vue?vue&type=template&id=4c66b3ac"
import script from "./movecartoondata.vue?vue&type=script&lang=js"
export * from "./movecartoondata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports